import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

const serverURL = getApiServer()

export const getAllHealthSystems = () => async (dispatch) => {
  dispatch({ type: types.GET_HEALTH_SYSTEMS_REQUESTED })
  try {
    const healthSystems = await axios.get(`${serverURL}/api/health-system`, { withCredentials: true })
    dispatch({ type: types.GET_HEALTH_SYSTEMS_FULFILLED, payload: healthSystems.data })
  } catch (error) {
    dispatch({ type: types.GET_HEALTH_SYSTEMS_REJECTED, payload: error.response.data })
  }
}

export const createHealthSystem = (client) => async (dispatch) => {
  dispatch({ type: types.CREATE_HEALTH_SYSTEM_REQUESTED })
  try {
    const newHealthSystem = await axios.post(`${serverURL}/api/health-system`, client, { withCredentials: true })
    dispatch({ type: types.CREATE_HEALTH_SYSTEM_FULFILLED, payload: newHealthSystem.data })
  } catch (error) {
    dispatch({ type: types.CREATE_HEALTH_SYSTEM_REJECTED, payload: error.response.data })
  }
}

export const getHealthSystem = (tenant = '') => async (dispatch) => {
  dispatch({ type: types.GET_HEALTH_SYSTEM_REQUESTED })
  try {
    let healthSystem
    if (tenant) {
      healthSystem = await axios.get(`${serverURL}/api/healthSystem`, { params: { tenant }, withCredentials: true })
    } else {
      healthSystem = await axios.get(`${serverURL}/api/healthSystem`, { withCredentials: true })
    }
    dispatch({ type: types.GET_HEALTH_SYSTEM_FULFILLED, payload: healthSystem.data })
  } catch (error) {
    dispatch({ type: types.GET_HEALTH_SYSTEM_REJECTED, payload: error })
  }
}

export const getContent = () => async (dispatch) => {
  dispatch({ type: types.GET_CONTENT_REQUESTED })
  try {
    const content = await axios.get(`${serverURL}/api/content`)
    dispatch({ type: types.GET_CONTENT_FULFILLED, payload: content.data })
  } catch (error) {
    dispatch({ type: types.GET_CONTENT_REJECTED, payload: error })
  }
}

export const getUsers = (healthSystemId) => async (dispatch) => {
  dispatch({ type: types.GET_HEALTH_SYSTEM_USERS_REQUESTED })
  try {
    const users = await axios.get(`${serverURL}/api/users`, { withCredentials: true, params: { healthSystemId } })
    dispatch({ type: types.GET_HEALTH_SYSTEM_USERS_FULFILLED, payload: users.data })
  } catch (error) {
    dispatch({ type: types.GET_HEALTH_SYSTEM_USERS_REJECTED, payload: error.response.data })
  }
}

export const createUser = (user) => async (dispatch) => {
  dispatch({ type: types.CREATE_USER_REQUESTED })
  try {
    const createdUser = await axios.post(`${serverURL}/api/user`, user, { withCredentials: true })
    dispatch({ type: types.CREATE_USER_FULFILLED, payload: createdUser.data })
  } catch (error) {
    dispatch({ type: types.CREATE_USER_REJECTED, payload: error.response.data })
  }
}

export const updateUser = (userId, status) => async (dispatch) => {
  dispatch({ type: types.UPDATE_USER_REQUESTED })
  try {
    const updatedUser = await axios.put(`${serverURL}/api/user/${userId}`, { status }, { withCredentials: true })
    dispatch({ type: types.UPDATE_USER_FULFILLED, payload: updatedUser.data })
  } catch (error) {
    dispatch({ type: types.UPDATE_USER_REJECTED, payload: error.response.data })
  }
}

export const deleteUser = (userId) => async (dispatch) => {
  dispatch({ type: types.DELETE_USER_REQUESTED })
  try {
    const deletedUser = await axios.delete(`${serverURL}/api/user/${userId}`, { withCredentials: true })
    dispatch({ type: types.DELETE_USER_FULFILLED, payload: deletedUser.data })
  } catch (error) {
    dispatch({ type: types.DELETE_USER_REJECTED, payload: error.response.data })
  }
}

export const getRules = (healthSystemId) => async (dispatch) => {
  dispatch({ type: types.GET_HEALTH_SYSTEM_RULES_REQUESTED })
  try {
    const rules = await axios.get(`${serverURL}/api/rule`, { withCredentials: true, params: { healthSystemId } })
    dispatch({ type: types.GET_HEALTH_SYSTEM_RULES_FULFILLED, payload: rules.data })
  } catch (error) {
    dispatch({ type: types.GET_HEALTH_SYSTEM_RULES_REJECTED, payload: error.response.data })
  }
}

export const updateRule = (opportunityId, rule) => async (dispatch) => {
  dispatch({ type: types.UPDATE_HEALTH_SYSTEM_RULE_REQUESTED })
  try {
    const updatedRule = await axios.post(`${serverURL}/api/rule`, rule, { withCredentials: true })
    dispatch({ type: types.UPDATE_HEALTH_SYSTEM_RULE_FULFILLED, payload: { opportunityId, rule: updatedRule.data } })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.UPDATE_HEALTH_SYSTEM_RULE_REJECTED, payload: error.response.data })
  }
}

export const getActions = (healthSystemId) => async (dispatch) => {
  dispatch({ type: types.GET_HEALTH_SYSTEM_ACTIONS_REQUESTED })
  try {
    const actions = await axios.get(`${serverURL}/api/action`, { withCredentials: true, params: { healthSystemId } })
    dispatch({ type: types.GET_HEALTH_SYSTEM_ACTIONS_FULFILLED, payload: actions.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.GET_HEALTH_SYSTEM_ACTIONS_REJECTED, payload: error.response.data })
  }
}

export const createAction = (action) => async (dispatch) => {
  dispatch({ type: types.CREATE_HEALTH_SYSTEM_ACTION_REQUESTED })
  try {
    const newAction = await axios.post(`${serverURL}/api/action`, action, { withCredentials: true })
    dispatch({ type: types.CREATE_HEALTH_SYSTEM_ACTION_FULFILLED, payload: newAction.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.CREATE_HEALTH_SYSTEM_ACTION_REJECTED, payload: error.response.data })
  }
}

export const sortActions = (sortBy) => (dispatch) => {
  dispatch({ type: types.SORT_HEALTH_SYSTEM_ACTIONS, payload: sortBy })
}

export const updateActionOrder = (actionId, name, value) => (dispatch) => {
  dispatch({ type: types.UPDATE_ACTION_ORDER, payload: { actionId, name, value } })
}

export const updateAction = (action) => async (dispatch) => {
  dispatch({ type: types.UPDATE_HEALTH_SYSTEM_ACTION_REQUESTED })
  try {
    const updatedAction = await axios.put(`${serverURL}/api/action/${action.actionId}`, action, { withCredentials: true })
    dispatch({ type: types.UPDATE_HEALTH_SYSTEM_ACTION_FULFILLED, payload: updatedAction.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.UPDATE_HEALTH_SYSTEM_ACTION_REJECTED, payload: error.response.data })
  }
}

export const deleteAction = (actionId) => async (dispatch) => {
  dispatch({ type: types.DELETE_HEALTH_SYSTEM_ACTION_REQUESTED })
  try {
    const deletedAction = await axios.delete(`${serverURL}/api/action/${actionId}`, { withCredentials: true })
    dispatch({ type: types.DELETE_HEALTH_SYSTEM_ACTION_FULFILLED, payload: deletedAction.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.DELETE_HEALTH_SYSTEM_ACTION_REJECTED, payload: error.response.data })
  }
}

export const addRuleAction = (opportunityId, ruleId, actionId) => async (dispatch) => {
  dispatch({ type: types.ADD_RULE_ACTION_REQUESTED })
  try {
    const ruleAction = await axios.post(`${serverURL}/api/rule-action`, { ruleId, actionId }, { withCredentials: true })
    dispatch({ type: types.ADD_RULE_ACTION_FULFILLED, payload: { opportunityId, ruleId, ruleAction: ruleAction.data[0] } })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.ADD_RULE_ACTION_REJECTED, payload: error.response.data })
  }
}

export const deleteRuleAction = (opportunityId, ruleId, actionId) => async (dispatch) => {
  dispatch({ type: types.DELETE_RULE_ACTION_REQUESTED })
  try {
    await axios.delete(`${serverURL}/api/rule-action`, { withCredentials: true, data: { ruleId, actionId } })
    dispatch({ type: types.DELETE_RULE_ACTION_FULFILLED, payload: { opportunityId, ruleId, actionId } })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.DELETE_RULE_ACTION_REJECTED, payload: error.response.data })
  }
}

export const resendSetup = (userId) => async (dispatch) => {
  dispatch({ type: types.RESEND_SETUP_REQUESTED })
  try {
    await axios.post(serverURL + '/api/setup', { userId }, { withCredentials: true })
    dispatch({ type: types.RESEND_SETUP_FULFILLED })
  } catch (error) {
    dispatch({ type: types.RESEND_SETUP_REJECTED })
  }
}

export const resetHealthSystemUserState = () => (dispatch) => {
  dispatch({ type: types.RESET_HEALTH_SYSTEM_USER_STATE })
}

export const resetHealthSystemRuleState = () => (dispatch) => {
  dispatch({ type: types.RESET_HEALTH_SYSTEM_RULE_STATE })
}

export const resetHealthSystemOrderState = () => (dispatch) => {
  dispatch({ type: types.RESET_HEALTH_SYSTEM_ORDER_STATE })
}

export const getReport = (values) => async (dispatch) => {
  dispatch({ type: types.GET_REPORT_REQUESTED })
  try {
    const report = await axios.get(`${serverURL}/api/report`, { withCredentials: true, params: values })
    dispatch({ type: types.GET_REPORT_FULFILLED, payload: report.data })
  } catch (error) {
    dispatch({ type: types.GET_REPORT_REJECTED, payload: error.response.data })
  }
}
